import { render, staticRenderFns } from "./DocsBanner.vue?vue&type=template&id=1e8706ed&scoped=true"
import script from "./DocsBanner.vue?vue&type=script&lang=js"
export * from "./DocsBanner.vue?vue&type=script&lang=js"
import style0 from "./DocsBanner.vue?vue&type=style&index=0&id=1e8706ed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e8706ed",
  null
  
)

export default component.exports